import React from 'react';
import { getConfig } from '../../../../../../utils/config';

function TnC({ handleTnC, handleOnChange, termsCheckbox }) {
    const config = getConfig();
    return (
        <div className={'mt-5 flex text-accent-content mb-3 gap-2'}>
            <input
                type="checkbox"
                checked={termsCheckbox}
                onChange={handleOnChange}
                className="checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600"
                autoComplete="off"
            />
            <p
                className={`${
                    config?.deals.dealLayout.termsAndConditionsClassName
                        ? config?.deals.dealLayout.termsAndConditionsClassName
                        : ' text-accent-content mx-auto text-sm break-words leading-4'
                }`}
            >
                I agree to the{' '}
                <button
                    onClick={handleTnC}
                    className="text-primary font-bold text-sm underline "
                >
                    Terms & Conditions
                </button>
            </p>
        </div>
    );
}

export default TnC;
